/**
 * @expFlag 3promo-enabled-public-animated-trend-modal
 * @ticket CLOUDWEB-20130
 * @file
 */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export const PROMO_ID = 'public-animated-trend-modal';

type publicAnimatedTrendModalType = {
    type: 'a' | 'b' | 'c' | 'd' | 'e';
    href: string;
};

export const publicAnimatedTrendModal: false | publicAnimatedTrendModalType =
    !IS_WEBVIEW && IS_MOBILE_BROWSER && getFeature(`3promo-enable-${PROMO_ID}`);
